var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-purchase-detail-item",class:{'sign-purchase-detail-item-a': _vm.active},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('clickItem', _vm.data)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }